const variants = {
  success: "bg-primary/10 text-primary border-primary/20",
  warning: "bg-secondary/10 text-secondary border-secondary/20",
  danger: "bg-red-500/10 text-red-400 border-red-500/20",
  info: "bg-tertiary/10 text-tertiary border-tertiary/20",
  default: "bg-bg-elevated text-text-muted border-border",
};

const Badge = ({ label, variant = "default" }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${variants[variant]}`}
  >
    {label}
  </span>
);

export default Badge;
